import { HttpEventType, HttpProgressEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileWebServiceInterface } from '@commons/file-picker/services/file.web-service.interface';
import { WizFile } from '@wizbii/models';
import { FileWebservice as FileApiWebservice } from '@wizbii/webservices';
import { concat, Observable } from 'rxjs';
import { distinct, filter, map, shareReplay } from 'rxjs/operators';

@Injectable()
export class FileWebService implements FileWebServiceInterface {
  constructor(private readonly fileApiWebservice: FileApiWebservice) {}

  get(fileId: string): Observable<any> {
    return this.fileApiWebservice.getDownloadBlob(fileId);
  }

  post(domFile: any): Observable<number | string> {
    const wizFile = new WizFile({ domFile });
    const result$ = this.fileApiWebservice.create(wizFile).pipe(shareReplay(1));

    const url$ = result$.pipe(
      filter((event) => event.type === HttpEventType.Response),
      map((event) => event as HttpResponse<{ id: string }>),
      map((event) => event.body.id)
    );

    const progress$ = result$.pipe(
      filter((event) => event.type === HttpEventType.UploadProgress),
      map((event) => event as HttpProgressEvent),
      map((event) => event.loaded / event.total),
      map((progress) => Math.ceil(progress * 10000) / 100),
      distinct()
    );

    return concat(progress$, url$);
  }
}
